import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
import { cn } from "@/lib/utils";
import { colors } from "@/utils/colors";

interface TablePaginationProps {
  currentPage: number;
  lastPage: number;
  total?: number;
  onChange: (page: number) => void;
}

export const TablePagination = ({
  currentPage,
  lastPage,
  total,
  onChange,
}: TablePaginationProps) => {
  if (lastPage <= 1) {
    return total ? (
      <span className="text-sm font-medium">Total de {total} registro(s)</span>
    ) : null;
  }

  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <span className="text-sm font-medium">
        Página {currentPage} de {lastPage}
        {total ? ` — ${total} registro(s)` : ""}
      </span>

      <Pagination className="justify-end">
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              href="#"
              className={cn("h-8", colors.bg_primary)}
              onClick={(event) => {
                event.preventDefault();
                if (currentPage > 1) onChange(currentPage - 1);
              }}
            />
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href="#" className="h-8" onClick={(event) => event.preventDefault()}>
              {currentPage}
            </PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationNext
              href="#"
              className={cn("h-8", colors.bg_primary)}
              onClick={(event) => {
                event.preventDefault();
                if (currentPage < lastPage) onChange(currentPage + 1);
              }}
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  );
};
